import "./LoadingSpinner.scss";

const LoadingSpinner = (props) => {
  const normalizeSize = (value, fallback = "48px") => {
    if (!value) return fallback;
    if (typeof value === "number") return `${value}px`;

    const trimmed = String(value).trim();
    const percentMatch = trimmed.match(/^(\d+(?:\.\d+)?)%$/);
    if (percentMatch) {
      const percent = Number(percentMatch[1]);
      const mappedPixels = Math.max(32, Math.min(84, Math.round(percent * 1.15)));
      return `${mappedPixels}px`;
    }

    return trimmed;
  };

  const size = normalizeSize(props.width || props.height);

  return (
    <div className="modern-loading-spinner" style={{ "--spinner-size": size }}>
      <span className="modern-loading-spinner-ring" />
    </div>
  );
};

export default LoadingSpinner;
